import { fetchEditorTemplates } from '~graphql/controllers';
import { displaySidebarTemplates } from '~src/sidebar/index';

export const handleTabTemplates = async (forceFetch = false) => {
  const response = await fetchEditorTemplates(forceFetch);

  window.editorConfig.sidebarTemplates = response.templates;
  window.editorConfig.sidebarTemplatesCategories = response.categories;

  displaySidebarTemplates();
};
